/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IDeadwoodRipData, IDeadwoodRipGameData} from "./IDeadwoodRipData";
import {IParsedStackedSymbolName, StackedSymbol} from "../../../core/reel/stackedsymbol/StackedSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DeadwoodRipGameConfig} from "../../DeadwoodRipGameConfig";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {DeadwoodRipReelController} from "../../reels/DeadwoodRipReelController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class DeadwoodRipDataParser {

    constructor() {

    }

    public parseReels(rawData:IDeadwoodRipData):string[][] {
        const filteredReels = this.parseStackedSymbolsInReels(rawData.reels);
        if(!!(<any>rawData)["isRestoreState"] && rawData.lowTransformList && rawData.lowTransformList.length > 0) {
            rawData.lowTransformList.forEach(l => {
                if(filteredReels[l.reel][l.row + 1] != "W") {
                    debugger;
                    Logger.logDev(`Server init data restore error! DeadwoodRipDataParser.parseReels: lowTransformList position doesn't match reels: reelId = ${l.reel} symbolId = ${l.row}`);
                }
                filteredReels[l.reel][l.row + 1] = l.symbolName;
            });
        }
        return filteredReels;
    }

    public parseStackedSymbolsInReels(rawReels:string[][], parsedSymbolNamesUnder?:string[]):string[][] {
        let result:string[][] = [];

        rawReels.forEach((rawReel, reelId) => {
            let reelSymbols:string[];
            if(reelId === 4) {
                reelSymbols = DeadwoodRipGameConfig.filterDoubleSizedSymbolReelSet(rawReel);
            } else {
                reelSymbols = rawReel.concat();
            }
            result.push(this.parseStackedSymbolsInReel(reelSymbols, reelId, parsedSymbolNamesUnder == null ? undefined : parsedSymbolNamesUnder[reelId]));
        });

        return result;
    }

    // Always start to parse the reel from the bottom because in all cases the bottom of the reel is already known.
    // For special cases like the reel is upside down, please create your own parsing.
    public parseStackedSymbolsInReel(rawReel:string[], reelIndex:number, parsedSymbolNameUnder?:string):string[] {
        const input:string[] = rawReel.concat();
        const result:string[] = [];

        if(parsedSymbolNameUnder == null) {
            let bottomStackedSymName:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1], reelIndex);
            // Find out if the reel has half stacked symbols in the bottom
            if(bottomStackedSymName.isStacked) {
                let i:number;
                for(i = 1; i < input.length; i++) {
                    const testStackedSymName:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1 - i], reelIndex);
                    if(testStackedSymName.isStacked && testStackedSymName.symName === bottomStackedSymName.symName) {
                        bottomStackedSymName = testStackedSymName;
                    } else {
                        break;
                    }
                }
                // i is the first symbol that's not in the stack.
                i = i % bottomStackedSymName.totalNum; // If num of stacked symbols in the bottom is bigger than stacked.totalNum.
                parsedSymbolNameUnder = `${bottomStackedSymName.symName}*${i.toString()}`;
            } else {
                parsedSymbolNameUnder = "NonStackedDummySym";
            }
        }

        while(input.length > 0) {
            const inputSymbol = input.pop()!
            if(inputSymbol.includes("S2")) {
                result.unshift(inputSymbol.replace("_", "*"));
                continue;
            }
            const stackedSymNameUnder:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(result.length > 0 ? result[0] : parsedSymbolNameUnder, reelIndex);
            const stackedSymName:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(inputSymbol, reelIndex);

            // For continue stacked symbol
            if(stackedSymNameUnder.isStacked && stackedSymNameUnder.index > 0) {
                if(!stackedSymName.isStacked || stackedSymName.symName !== stackedSymNameUnder.symName) {
                    debugger;
                    Logger.logDev("If you are using the outcome setter, this might be a case that the outcome made an illegal server data. Please take to the server dev to check if that worth a fix.");
                    throw new Error(`ServerDataParser.parseStackedSymbolsInReel():reelId = ${reelIndex}, reelData = ${rawReel.toString()}, symName = ${stackedSymName.symName}, the symbol should be ${stackedSymName.totalNum}-stacked!`);
                }
                result.unshift(`${stackedSymName.symName}*${(stackedSymNameUnder.index - 1).toString()}`);
                continue;
            }

            // For starting a new stacked symbol
            if(stackedSymName.isStacked) {
                result.unshift(`${stackedSymName.symName}*${(stackedSymName.totalNum - 1).toString()}`);
                continue;
            }

            // For non stacked symbol
            result.unshift(stackedSymName.symName);
        }

        return result;
    }

    public parseS1Positions(rawData:IDeadwoodRipData):number[] {
        const reelNum = DeadwoodRipReelController.SYMBOLS_NUM_IN_DATA.length;
        const result = ArrayHelper.initArrayWithValues(reelNum, reelId => -1);
        for(let reelId = 1; reelId < reelNum; reelId++) {
            const reelConfig = DeadwoodRipReelController.SYMBOLS_NUM_IN_DATA[reelId];
            const symStartId = reelConfig[1];
            for(let symId = symStartId; symId < symStartId + reelConfig[2]; symId++) {
                if(rawData.reels[reelId][symId] === "S1") { // TODO: change symbol name like S1.
                    if(result[reelId] === -1) {
                        result[reelId] = symId - symStartId;
                    } else {
                        debugger;
                        throw new Error(`Server gives more than 1 S1 on reel ${reelId}!`);
                        // https://github.com/nolimitcity/tombstonerip/issues/393
                        // rawData.reels[reelId][symId] = this.findLowestNoWinSymbol(rawData.reels[0])
                    }
                }
            }
        }

        Logger.logDev(`S1 position ${result.toString()}`);
        return result;
    }

    public parseS3Positions(rawData:IDeadwoodRipData):number[] {
        const result = ArrayHelper.initArrayWithValues(DeadwoodRipReelController.SYMBOLS_NUM_IN_DATA.length, reelId => -1);
        result[1] = this.findS3OnReel(rawData.reels[1]);
        result[3] = this.findS3OnReel(rawData.reels[3]);

        return result;
    }

    private findS3OnReel(reelData:string[]):number {
        // https://github.com/nolimitcity/deadwoodrip/issues/225
        const indexes:number[] = [];
        reelData.forEach((symName, index) => {
            if(symName === "S3") {
                indexes.push(index);
            }
        });
        for(let i = 0; i < indexes.length; i++) {
            if(indexes[i] > 0 && indexes[i] < 5) {
                return indexes[i] - 1;
            }
        }

        return -1;
    }

    // Game Data:

    public parseTransformScatterToReelSplit(scatterPositions:number[], mode:string):number[] {
        if(mode === GameMode.NORMAL) {
            let counter = 0;
            for(let reelId = 1; reelId < 4; reelId++) {
                if(scatterPositions[reelId] > -1) {
                    counter++;
                }
            }

            if(counter === 2) {
                return [-1, scatterPositions[1], scatterPositions[2], scatterPositions[3], -1];
            }
        }

        return ArrayHelper.initArrayWithValues(DeadwoodRipReelController.SYMBOLS_NUM_IN_DATA.length, reelId => -1);
    }

    public parseReelSplit(rawData:IDeadwoodRipGameData, transformS1ToReelSplit:number[]):boolean[] {
        const result = ArrayHelper.initArrayWithValues(DeadwoodRipReelController.SYMBOLS_NUM_IN_DATA.length, reelId => false);
        for(let reelId = 1; reelId < 4; reelId++) {
            for(let symId = 1; symId < 5; symId++) {
                if(rawData.reels[reelId][symId] === "WRS") {
                    result[reelId] = true;
                    break;
                }
            }
        }

        //WRS and S1 can never appear on the same reel.
        transformS1ToReelSplit.forEach((symId, reelId) => {
            if(symId > -1) {
                result[reelId] = true;
            }
        });

        return result;
    }

    public parseWinRatio(winRatio:number):IWinRatioConfig | null {
        let ratioConfigs:IWinRatioConfig[] = DeadwoodRipGameConfig.WIN_RATIOS;

        let ratioConfig;
        for(let i:number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if((winRatio > config.ratio) || (!config.startRatioExcluded && winRatio == config.ratio)) {
                ratioConfig = config;
                break;
            }
        }

        if(ratioConfig) {
            const result = {
                ratio : winRatio,
                startRatioExcluded : ratioConfig.startRatioExcluded,
                name : ratioConfig.name,
                duration : ratioConfig.duration,
                winLevel : ratioConfig.winLevel,
                bigWinLevel : ratioConfig.bigWinLevel
            };
            Logger.logDev(`winRatio = ${winRatio}, winLevel = ${ratioConfig.name}`);
            return result;
        }
        return null;
    }

    public parseNearWinReels(scatterPositions:number[], wasFeatureBuy:boolean, mode:string):boolean[] {
        const result = ArrayHelper.initArrayWithValues(DeadwoodRipReelController.SYMBOLS_NUM_IN_DATA.length, reelId => false);
        if(wasFeatureBuy) {
            if(SlotGame.apiPlugin.betFeatureController.getActiveBetFeature()?.name.includes("LUCKY_DRAW") && mode === GameMode.NORMAL) {
                result[4] = true;
                return result;
            }
            if(mode.includes("FREESPIN") && scatterPositions[1] > -1 && scatterPositions[2] > -1) {
                result[3] = true;
            }
            return result;
        }

        if(scatterPositions[1] > -1 && scatterPositions[2] > -1) {
            result[3] = true;
            //if you have scatter on last reel
            if(scatterPositions[3] > -1 && mode === GameMode.NORMAL) {
                result[4] = true;
            }
        }

        return result;
    }
}